import { render, staticRenderFns } from "./NonTradeGLTransactionList.vue?vue&type=template&id=56c17d9d&"
import script from "./NonTradeGLTransactionList.vue?vue&type=script&lang=js&"
export * from "./NonTradeGLTransactionList.vue?vue&type=script&lang=js&"
import style0 from "./NonTradeGLTransactionList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports